import { createStore } from 'vuex'

export default createStore({
  state:{
    routers: {},
    user: {},
    cache: {},
    page: {},
    loading: false,
    params: {},
    // 多页标签状态
    visitedTabs: [], // [{ path: '/xxx', name: '页面名', icon: 'ios-home', closable: true }]
    activeTab: '',
    jsc:{
      sbtxSwiper: true,//设备提醒轮播
        ssyjSwiper:true,//实时预警轮播
        isScale:true,//是否进行全局适配
        defaultOption: {
            step: 4.4, // 数值越大速度滚动越快
            hoverStop: true, // 是否开启鼠标悬停stop
            openWatch: true, // 开启数据实时监控刷新dom
            direction: 1, // 0向下 1向上 2向左 3向右
            limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
            singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
            singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
            waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
          },
        echartsAutoTime:3000,//echarts 图自动请求接口时间
    }
  },
  mutations: {
    ADD_VISITED_TAB(state, tab) {
      if (!state.visitedTabs.find(t => t.path === tab.path)) {
        state.visitedTabs.push(tab)
      }
    },
    REMOVE_VISITED_TAB(state, path) {
      state.visitedTabs = state.visitedTabs.filter(tab => tab.path !== path)
    },
    REMOVE_OTHER_TABS(state, path) {
      state.visitedTabs = state.visitedTabs.filter(tab => tab.path === path)
    },
    REMOVE_ALL_TABS(state) {
      state.visitedTabs = []
    },
    SET_ACTIVE_TAB(state, path) {
      state.activeTab = path
    }
  }
})
